export type RegistrationModelSerialRequiredType =
  | 'modelNumber'
  | 'serialNumber';
